/**
 * Saved alerts live on their own tab of the communication preferences page. The hash is what
 * `PreferenceCentrePage` reads on mount to open that tab, so alert confirmations must keep it —
 * without it the user lands on the default tab and has to find the alerts themselves.
 */
export const MANAGE_ALERTS_PATH = '/account/communication-preferences#saved-alerts'
